'use-client';
import * as React from 'react';
import type { ThumbnailsProps } from '../Thumbnails.types';
import TPAGallery from '../../TPAGallery/viewer/TPAGallery';

const Thumbnails: React.FC<ThumbnailsProps> = props => {
  return <TPAGallery {...props}></TPAGallery>;
};

export default Thumbnails;
